// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';

import { ArrowRight } from '@carbon/icons-react';

interface ChatInputProps {
  inputValue: string;
  setInputValue: (_value: string) => void;
  isThinking: boolean;
  sessionId: string | undefined;
  onSubmit: (_e: React.FormEvent | React.KeyboardEvent) => void;
  /** Overrides the prompt text; the advisory surface asks about SOPs, not sites. */
  placeholder?: string;
  /** Advisory surface has no debug use for the raw session id; keep it out of the UI there. */
  hideSessionId?: boolean;
}

const DEFAULT_PLACEHOLDER = 'Ask me anything about your sites...';

function ChatInput({
  inputValue,
  setInputValue,
  isThinking,
  sessionId,
  onSubmit,
  placeholder = DEFAULT_PLACEHOLDER,
  hideSessionId = false,
}: ChatInputProps) {
  return (
    <form className="chat-input-form" onSubmit={onSubmit}>
      <div className="chat-input-wrapper">
        <textarea
          value={inputValue}
          onChange={e => setInputValue(e.target.value)}
          placeholder={placeholder}
          className="chat-input"
          rows={2}
          aria-label="Type your message to the AI assistant"
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              onSubmit(e);
            }
          }}
        />
        {sessionId && !hideSessionId && (
          <div className="session-id-display">Session: {sessionId}</div>
        )}
      </div>
      <button
        type="submit"
        className="chat-send-btn"
        disabled={!inputValue.trim() || isThinking}
        aria-label="Send"
      >
        <ArrowRight size={20} />
      </button>
    </form>
  );
}

export default ChatInput;
